module.exports = __webpack_public_path__ + "img/lifecycle.e4abfabe.jpg";